<template>
  <div class="cw-mfa-verification">
    <div class="mfa-header is-size-5" v-if="showHeader">
      <p class="subtitle" v-if="message">{{ message }}</p>
      <p class="phone-number" v-if="phoneNumber">
        {{ maskPhoneNumber(phoneNumber) }}
      </p>
    </div>

    <form class="form" @submit.prevent="handleVerify">
      <div class="field">
        <cw-otp-input
          v-model="code"
          :hasError="hasError"
          @complete="handleVerify"
        />
        <p class="help is-danger has-text-centered" v-if="errorMessage">
          {{ errorMessage }}
        </p>
      </div>

      <div class="field is-grouped is-grouped-centered" v-if="showResend">
        <div class="control">
          <button
            class="button is-medium is-text"
            type="button"
            @click="handleResend"
            :disabled="resending"
          >
            {{ resending ? 'Sending...' : 'Resend Code' }}
          </button>
        </div>
      </div>

      <div class="field is-grouped is-grouped-right">
        <div class="control" v-if="showCancel">
          <button
            class="button is-medium is-light is-rounded"
            type="button"
            @click="handleCancel"
          >
            {{ cancelText }}
          </button>
        </div>
        <div class="control">
          <button
            class="button is-medium is-primary is-rounded"
            type="submit"
            :disabled="code.length !== 6"
          >
            {{ submitText }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import OTPInput from '@/components/cwkit/OTPInput';

export default {
  name: 'cw-mfa-verification',
  components: {
    'cw-otp-input': OTPInput,
  },
  props: {
    title: {
      type: String,
      default: 'Two-Factor Authentication',
    },
    message: {
      type: String,
      default: "We've sent a 6-digit verification code to",
    },
    phoneNumber: {
      type: String,
      default: null,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    submitText: {
      type: String,
      default: 'Verify & Complete',
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    showResend: {
      type: Boolean,
      default: true,
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      code: this.value || '',
      resending: false,
    };
  },
  computed: {
    hasError() {
      return !!this.errorMessage;
    },
  },
  watch: {
    value(newVal) {
      this.code = newVal || '';
    },
    code(newVal) {
      this.$emit('input', newVal);
      this.$emit('update:value', newVal);
    },
  },
  methods: {
    handleVerify() {
      if (this.code.length === 6) {
        this.$emit('verify', this.code);
      }
    },
    async handleResend() {
      this.resending = true;
      try {
        await this.$emit('resend');
      } finally {
        this.resending = false;
      }
    },
    handleCancel() {
      this.$emit('cancel');
    },
    maskPhoneNumber(phone) {
      if (!phone || phone.length <= 4) return phone;
      return phone.slice(0, -4).replace(/\d/g, '*') + phone.slice(-4);
    },
    clear() {
      this.code = '';
    },
  },
};
</script>

<style lang="stylus" scoped>
.cw-mfa-verification
  width 100%

.mfa-header
  text-align center
  margin-bottom 2rem

  .subtitle
    color rgba(46, 46, 46, 0.7)
    margin-top 0.5rem
    margin-bottom 0.25rem

  .phone-number
    color #4e8793
    font-weight 500
    margin-bottom 1rem

.field.is-grouped.is-grouped-centered
  justify-content center
  margin-bottom 1rem
  margin-top 1rem
</style>
